import { render } from "./HomeFeatured.vue?vue&type=template&id=d2f94db6"
import script from "./HomeFeatured.vue?vue&type=script&lang=js"
export * from "./HomeFeatured.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__